import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './RadioGroup.module.scss';
import RadioGroupContext from './RadioGroupContext';

function RadioGroup(props) {
  const context = useMemo(
    () => ({
      name: props.name,
      selectedValue: props.selectedvalue,
      onChange: props.onChange,
    }),
    [props.name, props.selectedvalue, props.onChange],
  );

  const classes = [styles.container];

  if (props.row) {
    classes.push(styles.row);
  }

  if (props.column) {
    classes.push(styles.column);
  }

  return (
    <RadioGroupContext.Provider value={context}>
      <div className={cn(classes)} role="radiogroup">
        {props.children}
      </div>
    </RadioGroupContext.Provider>
  );
}

export default RadioGroup;

RadioGroup.defaultProps = {
  row: false,
  column: false,
};

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  selectedvalue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  row: PropTypes.bool,
  column: PropTypes.bool,
};
